export default {
  name: 'Intro',
}
